import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import PricingPlans from "@/components/PricingPlans";
import { ExpandableDisclaimer } from "@/components/Compliance";
import usePageMeta from "@/hooks/usePageMeta";

export default function PlatformAccess() {
  usePageMeta({
    title: "Adviserz Platform — Coming Soon | Market Intelligence & Analytics",
    description:
      "The Adviserz market intelligence platform is in development. Indicative pricing is shown for information only — no plan is available for purchase and no payment is collected.",
    canonical: "https://adviserz.in/pricing",
  });

  return (
    <div className="min-h-screen bg-surface-base text-white">
      <SiteHeader />

      <section className="relative overflow-hidden border-b border-white/[0.06]">
        <div className="absolute inset-0 grid-bg grid-radial-mask" />
        <div className="absolute inset-0 spotlight-column opacity-70" />
        <div className="relative max-w-6xl mx-auto px-6 md:px-12 pt-36 md:pt-44 pb-16 md:pb-20">
          <div className="overline mb-6">Platform Access</div>
          <h1 className="font-display font-medium text-[36px] sm:text-5xl lg:text-[60px] leading-[1.05] tracking-tighter">
            Adviserz Platform <br />
            <span className="brand-text-gradient">— Coming Soon.</span>
          </h1>
          <p className="mt-8 text-base md:text-lg text-zinc-400 max-w-3xl leading-relaxed">
            We are currently developing our next-generation market intelligence platform. Product availability and
            commercial offerings will be announced following completion of applicable regulatory and compliance
            requirements.
          </p>
          <p className="mt-5 text-sm text-zinc-500 max-w-3xl leading-relaxed">
            No subscription, plan or service is available for purchase on this website today, and no payment is
            collected for research, analytics or any investment-related service.
          </p>
        </div>
      </section>

      <section className="bg-surface-base">
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-16 md:py-24">
          <div className="label-xs mb-8">Planned capability tiers · Indicative pricing</div>
          <PricingPlans />
          <div className="mt-12">
            <ExpandableDisclaimer testid="pricing-disclaimer" />
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
